import { IBadge, IAttribute, IActiveBadge } from '../types/iBadge';

const extractBadgeMeta = (attributes: IAttribute[] = []) => {
    const order = parseInt(attributes.find((a) => a.key === 'badge_order')?.value || '0', 10);
    const id = attributes.find((a) => a.key === 'badge_id')?.value || '';
    return { order, id };
};

export const extractSortedBadgeIds = (badges: IBadge[]) => {
    return badges
        ? badges
              .map(({ attributes }) => {
                  const { order, id } = extractBadgeMeta(attributes);
                  return order && id ? { order, id } : null;
              })
              .filter(Boolean)
              .sort((a, b) => a.order - b.order)
              .map((item) => item.id)
        : [];
};

export const getBadgeUrlsByActivity = (ids: string[], activeBadge: IActiveBadge, gamificationConfigs) => {
    if (!gamificationConfigs?.badges) return [];

    return ids.map((id, index) => {
        const badge = gamificationConfigs.badges[id];
        if (!badge?.imageUrls) return '';

        const key = index <= activeBadge?.index ? 'badge_active_image' : 'badge_inactive_image';
        const image = badge.imageUrls.find((img) => img.key === key);

        return image?.urlSVG || '';
    });
};

export const getActiveBadge = (
    badges: IBadge[],
    gamificationConfigs,
    defaultBadge: null | number = null
): IActiveBadge => {
    if (defaultBadge !== null) {
        const matchingBadge = badges.find((badge) => {
            const { order } = extractBadgeMeta(badge.attributes);
            return order === defaultBadge + 1;
        });

        if (matchingBadge) {
            const { id } = extractBadgeMeta(matchingBadge.attributes);
            const badgeLocalization = gamificationConfigs.badges[id]?.badgeTitleKey || '';
            return { badge: matchingBadge, index: defaultBadge, level: defaultBadge + 1, name: badgeLocalization };
        }
    }

    return badges.reduce<IActiveBadge>(
        (result, badge) => {
            const { order, id } = extractBadgeMeta(badge.attributes);
            if (order > result.level) {
                const badgeLocalization = gamificationConfigs.badges[id]?.badgeTitleKey || '';
                return { badge, index: order - 1, level: order, name: badgeLocalization };
            }
            return result;
        },
        { badge: null, index: 0, level: 0, name: '' }
    );
};
